module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cd-Da-Eb.8697e4f0.png";